/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_NscticketsInputs */

const en_colleague_action_nsctickets = /** @type {(inputs: Colleague_Action_NscticketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nscTickets`)
};

const ja_colleague_action_nsctickets = /** @type {(inputs: Colleague_Action_NscticketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nscTickets`)
};

const fr_colleague_action_nsctickets = /** @type {(inputs: Colleague_Action_NscticketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nscTickets`)
};

const de_colleague_action_nsctickets = /** @type {(inputs: Colleague_Action_NscticketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nscTickets`)
};

/**
* | output |
* | --- |
* | "nscTickets" |
*
* @param {Colleague_Action_NscticketsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_nsctickets = /** @type {((inputs?: Colleague_Action_NscticketsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_NscticketsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_nsctickets(inputs)
	if (locale === "ja") return ja_colleague_action_nsctickets(inputs)
	if (locale === "fr") return fr_colleague_action_nsctickets(inputs)
	return de_colleague_action_nsctickets(inputs)
});